<template>
  <div class="con">
    <el-card class="box-card">
  <div class="text item">
    <el-divider content-position="left">WAN</el-divider>
    <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
      <el-form-item label="开启：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="开启：" prop="name">
        <el-select placeholder="请选择" v-model="GroupingValue" size="mini" class="Form-Input-Width">
          <el-option
            v-for="item in GroupingList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计算开销：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="半双工：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="下载速度（kbit/s）：" prop="name">
        <el-input size="mini" class="Form-Input-Width"></el-input>
      </el-form-item>
      <el-form-item label="上传速度（kbit/s）：" prop="name">
        <el-input size="mini" class="Form-Input-Width"></el-input>
      </el-form-item>
      </el-form>
  </div>
</el-card>
    <el-card class="box-card">
  <div class="text item">
    <el-form ref="ruleForms" label-width="200px" class="demo-ruleForm">
      <el-divider content-position="left">3GWAN1</el-divider>
      <el-form-item label="开启：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="开启：" prop="name">
        <el-select placeholder="请选择" v-model="GroupingValue" size="mini" class="Form-Input-Width">
          <el-option
            v-for="item in GroupingList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计算开销：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="半双工：" prop="name">
        <el-checkbox v-model="checked"></el-checkbox>
      </el-form-item>
      <el-form-item label="下载速度（kbit/s）：" prop="name">
        <el-input size="mini" class="Form-Input-Width"></el-input>
      </el-form-item>
      <el-form-item label="上传速度（kbit/s）：" prop="name">
        <el-input size="mini" class="Form-Input-Width"></el-input>
      </el-form-item>
      </el-form>
  </div>
</el-card>
      <el-card class="box-card">
  <div class="text item">
    <el-form ref="ruleFormss" label-width="200px" class="demo-ruleForm">
      <el-divider content-position="left">分类规则</el-divider>
      <el-table
    :data="data"
    style="width: 100%">
    <el-table-column
      label="目标" align="center">
      <template slot-scope="scope">
        <el-select placeholder="请选择" v-model="scope.row.RuleValue" size="mini" class="Table-Input">
          <el-option
            v-for="item in RuleList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column
      label="源主机" align="center">
      <template slot-scope="scope">
        <select-input :widths="1.4"></select-input>
      </template>
    </el-table-column>
    <el-table-column
      label="目的主机" align="center">
      <template slot-scope="scope">
        <select-input :widths="1.4"></select-input>
      </template>
    </el-table-column>
    <el-table-column
      label="协议" align="center">
      <template slot-scope="scope">
        <select-input :widths="1.4"></select-input>
      </template>
    </el-table-column>
    <el-table-column
      label="端口" align="center">
      <template slot-scope="scope">
        <select-input :widths="1.4"></select-input>
      </template>
    </el-table-column>
    <el-table-column
      label="字节数" align="center">
      <template slot-scope="scope">
        <el-input size="mini"></el-input>
      </template>
    </el-table-column>
    <el-table-column
      label="备注" align="center">
      <template slot-scope="scope">
        <el-input size="mini"></el-input>
      </template>
    </el-table-column>
    <el-table-column>
      <template slot-scope="scope">
        <el-button type="danger" size="mini">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
      <el-form-item>
        <el-button type="primary" size="mini">添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-card>
  </div>
</template>
<script>
import SelectInput from '../SelectInput/index'
export default {
  data(){
    return{
      checked:true,
      GroupingList:[
        {
          value:'默认',
          label:'默认'
        }
      ],
      GroupingValue:'默认',
      data:[{RuleValue:'最高'},{RuleValue:'高'},{RuleValue:'普通'}],
      RuleList:[
        {value:'最高',label:'最高'},
        {value:'高',label:'高'},
        {value:'普通',label:'普通'},
        {value:'低',label:'低'}
      ]
    }
  },
  components:{
    SelectInput
  }
}
</script>
<style scoped>
.con {
  width: 100%;
  margin: 0 auto;
}
.Form-Input-Width {
  width: 5rem;
}
.Form-Buttom {
  margin-left: 0.2rem;
}
.checked{
  margin-left:1rem; 
}
.Table-Input{
  width: 1.4rem;
}
.text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }
  .box-card {
    margin: 20px 0px;
  }
  .Config-Buttom{
  display:table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
</style>
